import { Map } from 'immutable';
import React, { useEffect } from 'react';
import { useAppSelector, useAppDispatch } from 'flow/hooks/useRedux';
import { generatePath, useHistory, useParams } from 'react-router-dom';

import { Sound } from 'flow/types/Sound';
import { routes } from 'flow/types/routes';
import { PbxParams } from 'flow/types/Params';
import { TypedMap } from 'flow/types/TypedMap';
import { homeActionUrlPath } from 'flow/utils';
import Page from 'flow/components/Setting/Page';
import { MiniAudioPlayer } from 'flow/components/AudioPlayers';
import { fetchDefaultSounds } from 'flow/actions/sounds-actions';
import { fetchQueue, updateQueue } from 'flow/actions/pbx-actions';
import SettingSelectableItem from '../ui-components/SettingSelectableItem';

const PbxQueueWaitingSound = () => {
    const dispatch = useAppDispatch();
    const history = useHistory();
    const { entityKey } = useParams<PbxParams>();

    useEffect(() => {
        dispatch(fetchQueue(entityKey));
    }, [dispatch, entityKey]);

    useEffect(() => {
        dispatch(fetchDefaultSounds());
    }, [dispatch]);

    const pbxDetails = useAppSelector((state) =>
        state.pbx.getIn(['queues', entityKey], Map()),
    );

    const handleBack = () => {
        history.push(
            generatePath(routes['pbx.queues.entityKey.settings'], {
                entityKey,
            }),
        );
    };

    const handleWaitingSound = (key: string) => {
        const queueDTO = {
            waitingSound: { key },
        };
        dispatch(updateQueue(entityKey, queueDTO));
        handleBack();
    };

    return (
        <Page header="pbx.waitingsound" onClickBack={handleBack}>
            <div className="gap-4">
                {pbxDetails
                    ?.getIn(['settings', 'waitingSounds'], Map())
                    .valueSeq()
                    .map((soundDTO: TypedMap<Sound>) => {
                        if (!soundDTO.has('playbackURL')) {
                            return null;
                        }

                        const playbackUrl = homeActionUrlPath(
                            `/${soundDTO.get('playbackURL')}`,
                        );

                        return (
                            <SettingSelectableItem
                                key={soundDTO.get('key')}
                                value={soundDTO.get('key')}
                                onClick={() =>
                                    handleWaitingSound(soundDTO.get('key'))
                                }
                                selected={pbxDetails.getIn([
                                    'waitingSound',
                                    'key',
                                ])}
                            >
                                <div className="flex items-center gap-1">
                                    <div>
                                        {playbackUrl ? (
                                            <MiniAudioPlayer
                                                url={playbackUrl}
                                                uniqueId={`user-sound-key${soundDTO.get(
                                                    'key',
                                                )}`}
                                            />
                                        ) : null}
                                    </div>

                                    <div>{soundDTO.get('description')}</div>
                                </div>
                            </SettingSelectableItem>
                        );
                    })}
            </div>
        </Page>
    );
};

export default PbxQueueWaitingSound;
